module.exports = __webpack_public_path__ + "static/media/Sysco_Logo.cf55a7e9.png";